import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { TrackingService } from '../services/tracking.service';

export const analyticsInterceptor: HttpInterceptorFn = (req, next) => {
    if (req.url.includes('/analytics/events')) return next(req);

    const tracking = inject(TrackingService);
    return next(req).pipe(
        catchError(err => {
            if (err instanceof HttpErrorResponse) {
                try {
                    const url = new URL(err.url ?? req.url);
                    tracking.trackError(err.status, url.pathname, req.method);
                } catch {
                    tracking.trackError(err.status, req.url, req.method);
                }
            }
            return throwError(() => err);
        }),
    );
};
